module.exports = __webpack_public_path__ + "2c3052666a213a114347d52bb0392f06.pdf";